import { fromJS } from 'immutable'

import * as actionTypes from './actionTypes'


const defaultState = fromJS({
    image_data: {
            "lc": 1,
            "type": "constructor",
            "id": [
                "langchain",
                "schema",
                "image",
                "Image"
            ],
            "kwargs": {
                "content": "https://picmod.oss-cn-shanghai.aliyuncs.com/Material/pic/%E5%A2%99%E7%BA%B8/3D%E5%A0%86%E5%A2%A8%E5%A2%99%E7%BA%B8/%E5%8C%AF%E6%9D%B1%E7%9B%9B_%E5%84%BF%E7%AB%A5%E5%AE%9A%E5%88%B6%E5%A2%99%E7%BA%B8%E5%9B%BE%E6%A1%88_350_180_207340.jpg?OSSAccessKeyId=LTAI5tBUi7PrVzqfFb72tn37&Expires=2055861355&Signature=sJ57CdxNsLf%2Fw35ZHloggnKzxrM%3D",
                "metadata": {
                    "description": null,
                    "created_at": "2025-02-26 00:35:58",
                    "updated_at": "2025-02-26 00:35:58",
                    "tags": [
                        "墙纸",
                        "3D堆墨墙纸"
                    ],
                    "image_id": "74e00e1af038213d9479f29ab2760283",
                    "id": 53190,
                    "name": "儿童定制墙纸图案",
                    "url": "https://picmod.oss-cn-shanghai.aliyuncs.com/Material/pic/%E5%A2%99%E7%BA%B8/3D%E5%A0%86%E5%A2%A8%E5%A2%99%E7%BA%B8/%E5%8C%AF%E6%9D%B1%E7%9B%9B_%E5%84%BF%E7%AB%A5%E5%AE%9A%E5%88%B6%E5%A2%99%E7%BA%B8%E5%9B%BE%E6%A1%88_350_180_207340.jpg?OSSAccessKeyId=LTAI5tBUi7PrVzqfFb72tn37&Expires=2055861355&Signature=sJ57CdxNsLf%2Fw35ZHloggnKzxrM%3D",
                    "meta_data": {
                        "suffix": ".jpg",
                        "max_price": "350.00",
                        "min_price": "180.00",
                        "detail_url": [
                            "Material/pic/案例2/兆材云库案例_30993_0_1740129734.jpg,/down/案例2/兆材云库案例_30993_1_1740129734.jpg,/down/案例2/兆材云库案例_30993_2_1740129734.jpg,/down/案例2/兆材云库案例_30993_3_1740129735.jpg,/down/案例2/兆材云库案例_30993_4_1740129735.jpg,/down/案例2/兆材云库案例_30993_5_1740129735.jpg"
                        ],
                        "supplier_name": "广州市汇东盛装饰材料有限公司",
                        "specifications": "{\"产品型号:\":\"DH0491\",\"产地:\":\"广东省\",\"成分:\":\"纤维纸\",\"幅宽(cm):\":\"2.8M定高\",\"色系:\":\"彩色系\",\"是否防水:\":\"无\",\"色牢度:\":\"3\",\"防火\\/阻燃等级:\":\"F\",\"是否无痕拼接:\":\"否\",\"品牌名称:\":\"匯東盛\",\"分类:\":\"墙纸\\/3D堆墨墙纸\",\"是否允许定制:\":\"是\"}"
                    },
                    "score": 0.0706
                }
            }
        },
})

const reducer = (state=defaultState, action) => {
    switch(action.type) {
        case actionTypes.SET_IMAGE_DATA:
            return state.merge({
                'image_data': fromJS(action.data),
            })
        default:
            return state
    }
}

export default reducer
